import React from 'react';
import { Box } from '@mui/material';
import { AppHeader } from '../components/layout/AppHeader';
import { TokenExpirationWarning } from '../components/auth';
import { DESIGN_TOKENS } from '../design-system/tokens/colors';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TokenExpirationWarning variant="snackbar" warningThreshold={10} />
      <AppHeader />
      <Box sx={{ 
        flex: 1, 
        backgroundColor: DESIGN_TOKENS.colors.background.default,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {children}
      </Box>
    </Box>
  );
};